export const extractOriginalFilename = (id: string, idPrefixedFilename: string): string => {
    // server adds ${file.id}_ prefix to filenames to make unique server side, so to match
    // server view of the filename to local name during uploads we need to strip it.
    return idPrefixedFilename?.replace(`${id}_`, "");
};

export const formatFileSize = (bytes: number): string => {
    const units = ["B", "KB", "MB", "GB", "TB", "PB"];
    if (bytes === 0) return "0B";

    const k = 1000;
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), units.length - 1);
    const size = bytes / Math.pow(k, i);

    return `${size.toFixed(1)}${units[i]}`;
}

/**
 * Returns true if path2 is the subdirectory of path 1, but not if they are the same
 * @param path1
 * @param path2
 */
export const isSubdirectory = (path1: string, path2: string): boolean => {
    const toLower = (p: string) => p.toLowerCase();
    const normalized1 = toLower(path1.endsWith('/') ? path1 : path1 + '/');
    const normalized2 = toLower(path2.endsWith('/') ? path2 : path2 + '/');
    return normalized2.startsWith(normalized1) && normalized1 !== normalized2;
};
